import { pick } from "lodash";

import { QTC } from "../../../constants";

import { Address } from "./address";
import { QTCMortgageeSearch } from "./mortgagee-search";
import { Location, LocationCount } from "./location";

const allFusions = {
  address: Address,
  location: Location,
  mortgageeSearch: QTCMortgageeSearch,
  "location-count": LocationCount
};

export const commercialFusions = pick(allFusions, QTC.COMMERCIAL_FUSIONS);
export const plFusions = pick(allFusions, QTC.PL_FUSIONS);

// Fusions to run in the sidebar navigation
export const navFusions = {
  "location-count": () => null
};
